import { render, staticRenderFns } from "./BulkAction.vue?vue&type=template&id=18307cba&scoped=true"
import script from "./BulkAction.vue?vue&type=script&lang=js"
export * from "./BulkAction.vue?vue&type=script&lang=js"
import style0 from "./BulkAction.vue?vue&type=style&index=0&id=18307cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18307cba",
  null
  
)

export default component.exports